import { colors } from '@globals/themes/defaultTheme'
import { semiBoldFontWeight } from '@globals/themes/themeConstants'
import { MediaObjectUrl } from '@kudos/http-client'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { SxProps } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import UserAvatar from '@shared/avatar/UserAvatar'
import UserNameDisplay from '@shared/userDisplay/UserNameDisplay'
import { T } from '@transifex/react'

const bannerStyle: SxProps = {
  backgroundColor: colors.greenExtraLight,
  px: 2,
  py: 1,
}

type DelegationBannerProps = {
  delegatorId?: string | null
  delegatorFirstName?: string
  delegatorLastName?: string
  delegatorAvatarUrls?: MediaObjectUrl | null
  hasBorderRadius?: boolean
}

const DelegationBanner: React.FC<DelegationBannerProps> = ({
  delegatorId,
  delegatorFirstName,
  delegatorLastName,
  delegatorAvatarUrls,
  hasBorderRadius = false,
}) => {
  const delegator = { id: delegatorId, firstName: delegatorFirstName, lastName: delegatorLastName }

  return (
    <Box sx={{ ...bannerStyle, borderRadius: hasBorderRadius ? '8px' : '0px' }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <UserAvatar
          tenantMemberId={delegatorId}
          firstName={delegatorFirstName}
          lastName={delegatorLastName}
          media={delegatorAvatarUrls}
          size={36}
        />
        <Typography variant="body1" sx={{ color: colors.greenDark }}>
          <T
            _str="You're sending on behalf of {name}"
            name={<UserNameDisplay user={delegator} sx={{ fontWeight: semiBoldFontWeight }} />}
          />
        </Typography>
      </Stack>
    </Box>
  )
}

export default DelegationBanner
